export default __webpack_public_path__ + "static/media/wordsinput_standard.4743e8d9.svg";